import { render, staticRenderFns } from "./CategoryThumbnails.vue?vue&type=template&id=ecd82e30&"
import script from "./CategoryThumbnails.vue?vue&type=script&lang=js&"
export * from "./CategoryThumbnails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports